import { $el, bind, getBooleanTypeAttr, getStrTypeAttr, removeAttrs, setCss, setHtml } from '../../dom-utils';
import { destroyElem, validComps } from '../../utils';
import { isFn } from '../../utils/check-type';
import PREFIX from '../prefix';
var Tag = /** @class */ (function () {
    function Tag() {
        this.VERSION = '1.0';
        this.COMPONENTS = $el('r-tag', { all: true });
        this._create(this.COMPONENTS);
    }
    Tag.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'tag');
        var CloseIcon = target.querySelector("." + PREFIX.icon + "-ios-close");
        var $this = target;
        var checked;
        return {
            events: function (_a) {
                var onClose = _a.onClose, onChange = _a.onChange;
                bind(target, 'click', function () {
                    checked = target.dataset.checked === 'true' ? true : false;
                    onChange && isFn(onChange, checked);
                });
                if (!CloseIcon)
                    return;
                bind(CloseIcon, 'click', function (e) {
                    e.stopPropagation();
                    onClose && isFn(onClose, $this);
                });
            }
        };
    };
    Tag.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var _a = _this._attrs(node), type = _a.type, size = _a.size, color = _a.color, checked = _a.checked, checkable = _a.checkable, closable = _a.closable;
            _this._setMainTemplate(node);
            _this._setType(node, type);
            _this._setIsChecked(node, checked);
            _this._setSize(node, size);
            _this._setColor(node, type, checkable, color);
            _this._setClosable(node, closable);
            _this._setCheckable(node, checkable);
            _this._handleClose(node, closable);
            removeAttrs(node, ['type', 'size', 'color', 'checked', 'checkable', 'closable']);
        });
    };
    Tag.prototype._setMainTemplate = function (node) {
        var content = setHtml(node);
        setHtml(node, "<span class=\"" + PREFIX.tag + "-text\">" + content + "</span>");
    };
    Tag.prototype._setType = function (node, type) {
        if (type)
            node.classList.add(PREFIX.tag + "-" + type);
        if (type === 'dot') {
            node.insertAdjacentHTML('afterbegin', "<span class=\"" + PREFIX.tag + "-dot-inner\"></span>");
        }
    };
    Tag.prototype._setIsChecked = function (node, checkable) {
        if (checkable !== 'true')
            return;
        node.classList.add(PREFIX.tag + "-checked");
    };
    Tag.prototype._setColor = function (node, type, checkable, color) {
        var _defaultColors = this._defaultColors;
        var isUseDefaultColor = _defaultColors().includes(color);
        var TagText = node.querySelector("." + PREFIX.tag + "-text");
        if (!color)
            return;
        if (isUseDefaultColor) {
            node.classList.add(PREFIX.tag + "-" + color);
        }
        else {
            setCss(node, 'background', "" + color);
            setCss(node, 'borderColor', "" + color);
        }
        if (color !== 'default' && type !== 'dot' && type !== 'border' && !checkable) {
            TagText === null || TagText === void 0 ? void 0 : TagText.classList.add(PREFIX.tag + "-color-white");
        }
        if (isUseDefaultColor && type === 'border') {
            TagText === null || TagText === void 0 ? void 0 : TagText.classList.add(PREFIX.tag + "-color-" + color);
        }
        else {
            setCss(TagText, 'color', "" + color);
        }
    };
    Tag.prototype._setSize = function (node, size) {
        if (!size)
            return;
        node.classList.add(PREFIX.tag + "-size-" + size);
    };
    Tag.prototype._setClosable = function (node, closable) {
        if (!closable)
            return;
        node.classList.add(PREFIX.tag + "-closable");
        node.insertAdjacentHTML('beforeend', "<i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-ios-close\"></i>");
    };
    Tag.prototype._setCheckable = function (node, checkable) {
        if (!checkable)
            return;
        node.classList.remove(PREFIX.tag + "-checked");
        var TagText = node.querySelector("." + PREFIX.tag + "-text");
        bind(node, 'click', function () {
            var isChecked = node.classList.contains(PREFIX.tag + "-checked");
            // @ts-ignore
            node.dataset.checked = !isChecked;
            node.classList[isChecked ? 'remove' : 'add'](PREFIX.tag + "-checked");
            TagText === null || TagText === void 0 ? void 0 : TagText.classList[isChecked ? 'remove' : 'add'](PREFIX.tag + "-color-white");
        });
    };
    Tag.prototype._handleClose = function (node, closable) {
        if (!closable)
            return;
        var CloseIcon = node.querySelector("." + PREFIX.icon + "-ios-close");
        bind(CloseIcon, 'click', function () {
            destroyElem(node, { fadeOut: true });
        });
    };
    Tag.prototype._defaultColors = function () {
        var COLORS = [
            'default',
            'primary',
            'success',
            'warning',
            'error',
            'blue',
            'green',
            'red',
            'yellow',
            'pink',
            'magenta',
            'volcano',
            'orange',
            'gold',
            'lime',
            'cyan',
            'geekblue',
            'purple'
        ];
        return COLORS;
    };
    Tag.prototype._attrs = function (node) {
        return {
            type: getStrTypeAttr(node, 'type', ''),
            size: getStrTypeAttr(node, 'size', ''),
            color: getStrTypeAttr(node, 'color', 'default'),
            checked: getStrTypeAttr(node, 'checked', 'true'),
            closable: getBooleanTypeAttr(node, 'closable'),
            checkable: getBooleanTypeAttr(node, 'checkable')
        };
    };
    return Tag;
}());
export default Tag;
